import { type FC } from "react";
import { twMerge } from "tailwind-merge";
import warnImg from "@/assets/icon/warning.svg";
import arrowImg from "@/assets/icon/arrow.svg";
import maleImg from "@/assets/icon/male.svg";
import maleSkyImg from "@/assets/icon/male_sky.svg";
import femaleImg from "@/assets/icon/female.svg";
import femalePinkImg from "@/assets/icon/female_pink.svg";
import languageImg from "@/assets/icon/language.svg";
import selectLangImg from "@/assets/icon/select_lang.svg";
import checkImg from "@/assets/icon/check.svg";
import checkRoundImg from "@/assets/icon/check_round.svg";
import qrcodeImg from "@/assets/icon/qrcode.svg";
import calendarImg from "@/assets/icon/calendar.svg";
import contactImg from "@/assets/icon/contact.svg";
import emailImg from "@/assets/icon/email.svg";
import personImg from "@/assets/icon/person.svg";
import addressImg from "@/assets/icon/address.svg";
import plusImg from "@/assets/icon/plus.svg";
import backImg from "@/assets/icon/back.svg";
import cameraImg from "@/assets/icon/camera.svg";
import outlineImg1 from "@/assets/icon/outline_1.svg";
import outlineImg2 from "@/assets/icon/outline_2.svg";
import successImg from "@/assets/icon/success.svg";
import dangerImg from "@/assets/icon/danger.svg";
import closeImg from "@/assets/icon/close.svg";
import searchImg from "@/assets/icon/search.svg";
import closeFillImg from "@/assets/icon/close_fill.svg";
import checkAreaImg from "@/assets/icon/check_area.svg";
import errorRoseImg from "@/assets/icon/error_rose.svg";
import checkGreenImg from "@/assets/icon/check_green.svg";
import documentImg from "@/assets/icon/document.svg";
import linkImg from "@/assets/icon/link.svg";

export type IconType =
  | "warning"
  | "arrow"
  | "male"
  | "female"
  | "maleSky"
  | "femalePink"
  | "language"
  | "check"
  | "checkRound"
  | "qrcode"
  | "calendar"
  | "contact"
  | "email"
  | "person"
  | "address"
  | "plus"
  | "back"
  | "camera"
  | "outline_1"
  | "outline_2"
  | "success"
  | "danger"
  | "close"
  | "checkGreen"
  | "errorRose"
  | "selectLang"
  | "search"
  | "closeFill"
  | "checkArea"
  | "document"
  | "link";

export const Icon: FC<{
  type?: IconType;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
}> = ({ type, className, onClick }) => {
  let url = "";
  switch (type) {
    case "warning":
      url = warnImg;
      break;
    case "arrow":
      url = arrowImg;
      break;
    case "male":
      url = maleImg;
      break;
    case "female":
      url = femaleImg;
      break;
    case "maleSky":
      url = maleSkyImg;
      break;
    case "femalePink":
      url = femalePinkImg;
      break;
    case "back":
      url = backImg;
      break;
    case "camera":
      url = cameraImg;
      break;
    case "outline_1":
      url = outlineImg1;
      break;
    case "outline_2":
      url = outlineImg2;
      break;
    case "language":
      url = languageImg;
      break;
    case "selectLang":
      url = selectLangImg;
      break;
    case "errorRose":
      url = errorRoseImg;
      break;
    case "checkGreen":
      url = checkGreenImg;
      break;
    case "check":
      url = checkImg;
      break;
    case "checkRound":
      url = checkRoundImg;
      break;
    case "qrcode":
      url = qrcodeImg;
      break;
    case "calendar":
      url = calendarImg;
      break;
    case "contact":
      url = contactImg;
      break;
    case "email":
      url = emailImg;
      break;
    case "person":
      url = personImg;
      break;
    case "address":
      url = addressImg;
      break;
    case "plus":
      url = plusImg;
      break;
    case "success":
      url = successImg;
      break;
    case "danger":
      url = dangerImg;
      break;
    case "close":
      url = closeImg;
      break;
    case "search":
      url = searchImg;
      break;
    case "closeFill":
      url = closeFillImg;
      break;
    case "checkArea":
      url = checkAreaImg;
      break;
    case "document":
      url = documentImg;
      break;
    case "link":
      url = linkImg;
      break;
    default:
      url = "";
      break;
  }
  if (url) {
    return (
      <img
        onClick={onClick}
        src={url}
        className={twMerge("size-4", className)}
      />
    );
  }
  return null;
};
